import type { ComponentType, ComponentProps, PropsWithoutRef } from 'react';

import Configuration from './Configuration';

/**
 * @param Component Component to wrap.
 * @returns A component that renders the passed component wrapped in a Configuration.
 */
const withConfiguration =
  <Comp extends ComponentType<any>>(Component: Comp) =>
  (props: PropsWithoutRef<ComponentProps<Comp>>) => (
    <Configuration>
      <Component {...(props as ComponentProps<Comp>)} />
    </Configuration>
  );

export default withConfiguration;
